import Polygon from "../shapes/layouts/polygon";
import {DIRECTION, IRONING_BOARD_DIRECTION} from "./cabinetShapes";

export const createIroningBoardShape = (width, height, radius, direction) => {
    const points = [];
    const steps = 20; // number of points for the arc

    // Straight lines
    points.push({ x: 0, y: 0 });
    points.push({ x: width, y: 0 });
    //points.push({ x: width, y: height});

    if (direction === IRONING_BOARD_DIRECTION.left) {
      for (let i = steps; i >= 0; i--) {
        const angle = (Math.PI / 2) * (i / steps); // quarter circle
        const x = width - radius * Math.cos(angle);
        const y = height - radius + radius * Math.sin(angle);
        points.push({x, y});
      }
    }

    if (direction === IRONING_BOARD_DIRECTION.right) {
      for (let i = 0; i <= steps; i++) {
        const angle = (Math.PI / 2) * (i / steps); // quarter circle
        const x = width - radius + radius * Math.cos(angle);
        const y = height - radius + radius * Math.sin(angle);
        points.push({ x, y });
      }
    }

    // Straight lines
    //points.push({ x: 0, y: height - radius });

    return new Polygon(points, true, true);
};

export const createBlindCornerShape = (width, depth, height, direction) => {
  const margin = 28;
  const gap = 1;

  if ( direction === DIRECTION.right ) {
    return new Polygon([
      { x: 0, y: 0 },
      { x: width, y: 0 },
      { x: width, y: depth },
      { x: margin, y: depth },
      { x: margin, y: depth - gap },
      { x: 0, y: depth - gap },
    ])
  } else if (direction === DIRECTION.left) {
    return new Polygon( [
      { x: 0, y: 0 },
      { x: width, y: 0 },
      { x: width, y: depth - gap },
      { x: width - margin, y: depth - gap },
      { x: width - margin, y: depth },
      { x: 0, y: depth },
    ])
  }
};
